import * as React from "react";
import {translate} from "react-i18next";
import {connect} from "react-redux";

// services
import {GroupDto, GroupDetailsDto} from "../../../services/Client";

// reducer
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";

// semantic
import {Table} from "semantic-ui-react";

import DetailsDialog from "./DetailsDialog";
import HATEOASClient from "../../../services/HATEOASClient";
import {selectClient} from "../../../redux/selectors";
import {compose} from "redux";
import {IReduxState} from "../../../redux/IReduxState";

interface IMapStateToProps {
    client: HATEOASClient;
}

interface IMapDispatchToProps { }

interface IOwnProps {
    /** The group to display. */
    group: GroupDto;

    /** Callback when the user closes the dialog. */
    onClose?: () => void;
}

interface IGroupDetailsDialogProps extends
    IOwnProps,
    IMapStateToProps,
    IMapDispatchToProps,
    ITranslatedComponent { }

/**
 * Shows the detail information of a specific group in a modal dialog.
 */
class GroupDetailsDialog extends React.Component<IGroupDetailsDialogProps> {
    renderDetails = (details?: GroupDetailsDto): JSX.Element => (
        <Table definition={true}>
            <Table.Body>
                <Table.Row>
                    <Table.Cell>{this.props.t("GROUP_NAME")}</Table.Cell>
                    <Table.Cell>{details && details.groupName && details.groupName}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>{this.props.t("MEMBERS")}</Table.Cell>
                    <Table.Cell>{details && details.member && details.member.join(", ")}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>{this.props.t("PARENT_GROUPS")}</Table.Cell>
                    <Table.Cell>{details && details.parentGroups && details.parentGroups.join(", ")}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>{this.props.t("ACCESS_RIGHTS")}</Table.Cell>
                    <Table.Cell style={{padding: '0'}}>
                        {details && this.renderAccessRights(details)}
                    </Table.Cell>
                </Table.Row>
            </Table.Body>
        </Table>
    )

    renderAccessRights = ({cnrs, typefamilies, modelyears}: any): JSX.Element => {

        const getAccessRights = (data: any, combineName = false) => {
            let combineGroups: any[] = [];

            data.map((el: any) => {
                if (el.permissionType.substring(0, 4) === "LDAP") {
                    combineGroups.push(
                        <span
                            style={{
                                color: ' rgb(255, 139, 0)',
                                border: '1.5px solid',
                                margin: '2px',
                                padding: '1px'
                            }}
                        >
                            {combineName ? `${el.mj4}(${el.mj1})` : el.name}
                        </span>
                    );
                } else if (el.permissionType.substring(0, 6) === "PRO_MT") {
                    combineGroups.push(
                        <span
                            style={{
                                color: 'rgb(76, 154, 255)',
                                border: '1.5px solid',
                                margin: '2px',
                                padding: '1px'
                            }}
                        >
                            {combineName ? `${el.mj4}(${el.mj1})` : el.name}
                        </span>
                    );
                }
                else combineGroups.push(
                    <span
                            style={{
                                fontWeight: 'bold',
                                border: '1.5px solid',
                                margin: '2px',
                                padding: '1px'
                            }}
                    >
                        {combineName ? `${el.mj4}(${el.mj1})` : el.name}
                    </span>
                    );
            });

            return combineGroups;
        };

        return (
            <Table
                style={{
                    borderCollapse: 'collapse',
                    borderColor: '#fff'
                }}
            >
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{this.props.t("MODELYEARS")}</Table.Cell>
                        <Table.Cell
                            className="display--flex flex--wrap"
                        >
                            {...getAccessRights(modelyears, true)}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("TYPEFAMILIES")}</Table.Cell>
                        <Table.Cell
                            className="display--flex flex--wrap"
                        >
                            {...getAccessRights(typefamilies)}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("CNRS")}</Table.Cell>
                        <Table.Cell
                            className="display--flex flex--wrap"
                        >
                            {...getAccessRights(cnrs)}
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }

    render() {
        return (
            <DetailsDialog
                headerText={this.props.t("GROUP_DETAILS")}
                onRequestDetails={() => this.props.client.GET_groupDetails(this.props.group).execute(this.props.group.groupName)}
                onRender={this.renderDetails}
                onClose={() => this.props.onClose && this.props.onClose()}
            />
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    client: selectClient(state)
});

export default compose<React.ComponentType<IOwnProps>>(
    translate("ADMIN_VIEW"),
    connect<IMapStateToProps>(mapStateToProps)
)(GroupDetailsDialog);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/GroupDetailsDialog.tsx